import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { RailLuckyDipItem } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';
import TG4Loader from '@/components/TG4Loader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LuckyDipCell',
  props: {
    item: null,
    loading: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: RailLuckyDipItem;
  loading?: boolean;
};






const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const isIrish = computed(() => currentLanguage.value === Language.Irish);

const title = computed(() => (isIrish.value ? props.item.titleGa : props.item.titleEn));

const subtitle = computed(() => {
  const value = isIrish.value ? props.item.subtitleGa : props.item.subtitleEn;
  return value ?? props.item.subtitleEn ?? '';
});

return { __sfc: true,props, emit, useGetter, currentLanguage, isIrish, title, subtitle, TG4Loader }
}

})